import { StandardComponents } from './types.js';

const INTRO_PAGES = {
  ApplicationProcess: {
    key: 'application-process',
    layout: 'steps',
    title: 'About the application process',
    steps: [
      {
        title: 'The application contains sensitive questions',
        icon: 'infoOutline',
        description: 'We recommend completing the application in a safe and private space.',
      },
      {
        title: 'It takes around 20 minutes to complete',
        icon: 'time',
        description: 'You can expect to spend 20 minutes or less filling out your application.',
      },
      {
        title: 'Your progress will be saved as you go',
        icon: 'checkCircleOutline',
        description:
          'If you need to come back to complete your application, you can start where you left off.',
      },
      {
        title: 'Your data is secure',
        icon: 'verifiedOutlined',
        description:
          'We will safely store your data to help you apply to future applications faster, and we will not share your data with third parties without your consent.',
      },
      {
        title: 'Check your inbox',
        icon: 'mail',
        description:
          'We will review your application and notify you of the decision as soon as possible.',
      },
    ],
  },
} as StandardComponents['definitions']['introPages'];
export default INTRO_PAGES;
